// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2PGj0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2ivNL"};